import * as moment from 'moment';
import * as Mutations from './mutations';
import { CampAddOn } from './camp-add-on';
import { SchoolCampService } from '@/common/services/pages/camp.service';
import * as _ from 'lodash';
import { TYPES } from '@/constants/ages-grades';
import { CampPricing } from './camp-pricing';
import router from '@/router';
import * as Routes from '@/router/routes';
import { SCHOOL_APP } from '@/main';
import {
    STEPS,
    DEFAULT_STATE,
    DEFAULT_STATE_EARLY_BIRD_DISCOUNT,
    DEFAULT_STATE_MULTI_CHILD_DISCOUNT,
    DEFAULT_STATE_MULTI_PROGRAM_DISCOUNT
} from '@/store/modules/camp-form/default-state';
import { PaginationParams } from '@/common/utils/pagination-params';
import { canGoToStep, setTodayIfPastDate } from '@/common/utils/step-form';


export const CampFormModule = {
    state: {
        isSubmitted: false,
        step: 1,
        form: _.cloneDeep(DEFAULT_STATE),
        steps: STEPS.map(el => ({
            name: el,
            valid: false
        })),
        discountsOpened: false,
        addOnsOpened: false,
        detailsOpened: false,
        formCopy: _.cloneDeep(DEFAULT_STATE),
        isDraft: false,
        duplicateCampForm: false
    },

    mutations: {
        [Mutations.CAMP_FORM_NEXT_STEP](state) {
            state.step++;
        },

        [Mutations.CAMP_FORM_GOTO_STEP](state, number) {
            if (canGoToStep(state, number)) {
                state.step = number;
            }
        },

        [Mutations.CAMP_FORM_SET_CAMP_NAME](state, campName) {
            state.form.camp.campName = campName;
        },

        [Mutations.CAMP_FORM_SET_INSTRUCTOR_ID](state, instructor) {
            state.form.camp.instructorId = instructor.id;
        },

        [Mutations.CAMP_FORM_SET_LOCATION_ID](state, location) {
            state.form.camp.locationId = location.id;
        },

        [Mutations.CAMP_FORM_SET_CAMP_DESCRIPTION](state, campDescription) {
            state.form.camp.description = campDescription;
        },

        [Mutations.CAMP_FORM_SET_FORM_VALID](state, valid) {
            state.steps[state.step - 1].valid = valid;
        },

        [Mutations.CAMP_FORM_SET_WEEK_DAYS](state, days) {
            state.form.camp.sunday = days.find(weekDay => weekDay.day === 'Sunday').selected;
            state.form.camp.monday = days.find(weekDay => weekDay.day === 'Monday').selected;
            state.form.camp.tuesday = days.find(weekDay => weekDay.day === 'Tuesday').selected;
            state.form.camp.wednesday = days.find(weekDay => weekDay.day === 'Wednesday').selected;
            state.form.camp.thursday = days.find(weekDay => weekDay.day === 'Thursday').selected;
            state.form.camp.friday = days.find(weekDay => weekDay.day === 'Friday').selected;
            state.form.camp.saturday = days.find(weekDay => weekDay.day === 'Saturday').selected;
        },

        [Mutations.CAMP_FORM_SET_CAMP_START_DATE](state, date) {
            state.form.camp.campStartDate = date;
        },

        [Mutations.CAMP_FORM_SET_CAMP_END_DATE](state, date) {
            state.form.camp.campEndDate = date;
        },

        [Mutations.CAMP_FORM_SET_NO_CAMP_DATES](state, dates) {
            state.form.camp.noCampDates = dates;
        },

        [Mutations.CAMP_FORM_SET_SIGN_UP_BEGINS_DATE](state, signUpBegins) {
            state.form.camp.signUpBeginsDate = signUpBegins;
        },

        [Mutations.CAMP_FORM_SET_SIGN_UP_BEGINS_TIME](state, signUpBegins) {
            state.form.camp.signUpBeginsTime = signUpBegins;
        },

        [Mutations.CAMP_FORM_SET_SIGN_UP_ENDS_DATE](state, signUpEnds) {
            state.form.camp.signUpEndsDate = signUpEnds;
        },

        [Mutations.CAMP_FORM_SET_SIGN_UP_ENDS_TIME](state, signUpEnds) {
            state.form.camp.signUpEndsTime = signUpEnds;
        },

        [Mutations.CAMP_FORM_SET_PRORATE](state, prorate) {
            state.form.camp.prorate = prorate;
        },

        [Mutations.CAMP_FORM_SET_PICKUP_OPTIONS](state, pickUpOptions) {
            state.form.camp.pickUpOptions = pickUpOptions;
        },

        [Mutations.CAMP_FORM_SET_PICKUP_OPTIONS_REQUIRED](state, pickUpOptionsRequired) {
            state.form.camp.pickUpOptionsRequired = pickUpOptionsRequired;
        },

        [Mutations.CAMP_FORM_SET_TEACHER](state, teacher) {
            state.form.camp.teacher = teacher;
        },

        [Mutations.CAMP_FORM_SET_TEACHER_REQUIRED](state, teacherRequired) {
            state.form.camp.teacherRequired = teacherRequired;
        },

        [Mutations.CAMP_FORM_SET_T_SHIRT](state, tshirt) {
            state.form.camp.tshirt = tshirt;
        },

        [Mutations.CAMP_FORM_SET_T_SHIRT_REQUIRED](state, tshirtRequired) {
            state.form.camp.tshirtRequired = tshirtRequired;
        },

        [Mutations.CAMP_FORM_ADD_ADDON](state) {
            state.form.addOns.push(new CampAddOn());
        },
        [Mutations.CAMP_FORM_SET_ADDON_NAME](state, {name, id}) {
            if (id) {
                state.form.addOns.find(addOn => addOn.id === id).name = name;
            }
        },

        [Mutations.CAMP_FORM_SET_ADDON_PRICE](state, {price, id}) {
            if (id) {
                state.form.addOns.find(addOn => addOn.id === id).price = price;
            }
        },

        [Mutations.CAMP_FORM_SET_ADDON_DISCOUNT](state, {discount, id}) {
            if (id) {
                state.form.addOns.find(addOn => addOn.id === id).discount = discount;
            }
        },

        [Mutations.CAMP_FORM_SET_ADDON_REQUIRED](state, {required, id}) {
            if (id) {
                state.form.addOns.find(addOn => addOn.id === id).required = required;
            }
        },

        [Mutations.CAMP_FORM_SET_ADDON_MAX_AMOUNT](state, {maxAmount, id}) {
            if (id) {
                state.form.addOns.find(addOn => addOn.id === id).maxAmount = maxAmount;
            }
        },

        [Mutations.CAMP_FORM_REMOVE_CAMP_ADDON](state, id) {
            const addOn = state.form.addOns.find(addOn => addOn.id === id);
            if (addOn) {
                if (addOn.new) {
                    const addOnIndex = state.form.addOns.findIndex(addOn => addOn.id === id);
                    state.form.addOns.splice(addOnIndex, 1);
                }
                else {
                    addOn.active = false;
                }
            }
        },

        [Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_ACTIVE](state, active) {
            state.form.multiChildDiscount.active = active;
        },

        [Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_BONUS_TYPE](state, bonusType) {
            if (bonusType === '') { bonusType = null }
            state.form.multiChildDiscount.bonusType = bonusType;
        },

        [Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_AMOUNT](state, amount) {
            state.form.multiChildDiscount.amount = amount;
        },

        [Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_NUMBER_OF_KIDS](state, after) {
            state.form.multiChildDiscount.after = after;
        },

        [Mutations.CAMP_FORM_SET_FIRST_CHILD_DISCOUNT](state, familyType) {
            state.form.multiChildDiscount.familyType = familyType;
        },

        [Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_ACTIVE](state, active) {
            state.form.multiProgramDiscount.active = active;
        },

        [Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_AMOUNT](state, amount) {
            state.form.multiProgramDiscount.amount = amount;
        },

        [Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_BONUS_TYPE](state, bonusType) {
            if (bonusType === '') { bonusType = null }
            state.form.multiProgramDiscount.bonusType = bonusType;
        },

        [Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_NUMBER_OF_KIDS](state, numberOfKids) {
            state.form.multiProgramDiscount.after = numberOfKids;
        },

        [Mutations.CAMP_FORM_SET_EARLY_BIRD_ACTIVE](state, active) {
            state.form.earlyBirdDiscount.active = active;
        },

        [Mutations.CAMP_FORM_SET_EARLY_BIRD_BONUS_TYPE](state, bonusType) {
            if (bonusType === '') { bonusType = null }
            state.form.earlyBirdDiscount.bonusType = bonusType;
        },

        [Mutations.CAMP_FORM_SET_EARLY_BIRD_AMOUNT](state, amount) {
            state.form.earlyBirdDiscount.amount = amount;
        },

        [Mutations.CAMP_FORM_SET_EARLY_BIRD_END_DATE](state, endDate) {
            state.form.earlyBirdDiscount.endDate = endDate;
        },

        [Mutations.CAMP_FORM_SET_TYPE](state, type) {
            state.type = type;
        },

        [Mutations.CAMP_FORM_SUBMIT](state, isSubmitted = true) {
            state.form = _.cloneDeep(DEFAULT_STATE);
            state.isSubmitted = isSubmitted;
            state.steps.forEach(step => step.valid = false);
            state.discountsOpened = false;
            state.addOnsOpened = false;
            state.detailsOpened = false;
            state.formCopy = _.cloneDeep(state.form);
        },

        [Mutations.CAMP_FORM_RESET](state) {
            state.form = _.cloneDeep(DEFAULT_STATE);
            state.isSubmitted = false;
            state.step = 1;
            state.steps.forEach(step => step.valid = false);
            state.discountsOpened = false;
            state.addOnsOpened = false;
            state.detailsOpened = false;
            state.formCopy = _.cloneDeep(state.form);
        },

        [Mutations.CAMP_FORM_SET_IS_DRAFT](state, isDraft) { 
            state.isDraft = isDraft;
        },

        [Mutations.CAMP_FORM_PREFILL](state, form) {
            state.steps.forEach(step => {
                step.valid = true;
            });
            if (!form.camp.prorate) {
                form.camp.prorate = state.form.camp.prorate;
            }
            if (!form.multiChildDiscount) {
                form.multiChildDiscount = _.cloneDeep(DEFAULT_STATE_MULTI_CHILD_DISCOUNT);
            }
            if (!form.earlyBirdDiscount) {
                form.earlyBirdDiscount = _.cloneDeep(DEFAULT_STATE_EARLY_BIRD_DISCOUNT);
            }
            if (!form.multiProgramDiscount) {
                form.multiProgramDiscount = _.cloneDeep(DEFAULT_STATE_MULTI_PROGRAM_DISCOUNT);
            }
            if (form.multiChildDiscount && form.multiChildDiscount.active ||
                form.earlyBirdDiscount && form.earlyBirdDiscount.active ||
                form.multiProgramDiscount && form.multiProgramDiscount.active) {
                state.discountsOpened = true;
            }
            if (form.camp.pickUpOptions || form.camp.teacher || form.camp.tshirt || form.camp.formIds.length) {
                state.detailsOpened = true;
            }
            if (!isEditForm()) {
                setTodayIfPastDate(form.camp, 'signUpBeginsDate');
                setTodayIfPastDate(form.camp, 'campStartDate');
            }
            if (form.addOns.length) {
                state.addOnsOpened = true;
            }
            delete form.camp.id;
            state.form = form;
            state.formCopy = _.cloneDeep(form);
        },

        [Mutations.CAMP_FORM_ADD_PRICING](state) {
            state.form.pricings.push(new CampPricing());
        },

        [Mutations.CAMP_FORM_REMOVE_PRICING](state, id) {
            state.form.pricings = state.form.pricings.filter(pricing => pricing.id !== id);
        },

        [Mutations.CAMP_FORM_SET_PRICING_NAME](state, {name, id}) {
            state.form.pricings.find(pricing => pricing.id === id).name = name;
        },

        [Mutations.CAMP_FORM_SET_PRICING_PRICE](state, {price, id}) {
            state.form.pricings.find(pricing => pricing.id === id).price = price;
        },

        [Mutations.CAMP_FORM_SET_PRICING_WAITLIST](state, {waitList, id}) {
            state.form.pricings.find(pricing => pricing.id === id).waitList = waitList;
        },

        [Mutations.CAMP_FORM_SET_PRICING_MAX_WAITLIST](state, {maxWaitList, id}) {
            state.form.pricings.find(pricing => pricing.id === id).maxWaitList = maxWaitList;
        },

        [Mutations.CAMP_FORM_SET_PRICING_MAX_ENROLL](state, {maxEnroll, id}) {
            state.form.pricings.find(pricing => pricing.id === id).maxEnroll = maxEnroll;
        },

        [Mutations.CAMP_FORM_SET_PRICING_BILLING_TYPE](state, {billingType, id}) {
            state.form.pricings.find(pricing => pricing.id === id).billingType = billingType;
        },

        [Mutations.CAMP_FORM_SET_PRICING_TIME_FROM](state, {timeFrom, id}) {
            state.form.pricings.find(pricing => pricing.id === id).timeFrom = timeFrom;
        },

        [Mutations.CAMP_FORM_SET_PRICING_TIME_TO](state, {timeTo, id}) {
            state.form.pricings.find(pricing => pricing.id === id).timeTo = timeTo;
            const minTimeTo = state.form.pricings
                .map(pricing => pricing.timeTo)
                .reduce((previous, current) => {
                    const [hours, minutes] = current.split(':');
                    const [previousHours, previousMinutes] = previous.split(':');
                    if (hours === previousHours) {
                        return minutes > previousMinutes ? current : previous;
                    }
                    else {
                        return hours > previousHours ? current : previous;
                    }
                }, '00:00');
            state.form.camp.signUpEndsTime = minTimeTo;
        },


        [Mutations.CAMP_FORM_SET_PRICING_GRADE_FROM](state, {gradeFrom, id}) {
            state.form.pricings.find(pricing => pricing.id === id).gradeFrom = gradeFrom;
        },

        [Mutations.CAMP_FORM_SET_PRICING_GRADE_TO](state, {gradeTo, id}) {
            state.form.pricings.find(pricing => pricing.id === id).gradeTo = gradeTo;
        },

        [Mutations.CAMP_FORM_SET_PRICING_AGE_FROM](state, {ageFrom, id}) {
            state.form.pricings.find(pricing => pricing.id === id).ageFrom = ageFrom;
        },

        [Mutations.CAMP_FORM_SET_PRICING_AGE_TO](state, {ageTo, id}) {
            state.form.pricings.find(pricing => pricing.id === id).ageTo = ageTo;
        },

        [Mutations.CAMP_FORM_SET_ADDONS_OPENED](state, addOnsOpened) {
            state.addOnsOpened = addOnsOpened;
        },

        [Mutations.CAMP_FORM_SET_DETAILS_OPENED](state, detailsOpened) {
            state.detailsOpened = detailsOpened;
        },

        [Mutations.CAMP_FORM_SET_DISCOUNTS_OPENED](state, discountsOpened) {
            state.discountsOpened = discountsOpened;
        },

        [Mutations.CAMP_FORM_DUPLICATE_TOGGLE] (state, duplicateCampForm) {
            state.duplicateCampForm = duplicateCampForm;
        },

        [Mutations.CAMP_FORM_SET_PRICING_PAID](state, { paid, id }) {
            state.form.pricings = state.form.pricings.map(pricing => {
                if (pricing.id === id) {
                    return { ...pricing, paid };
                }
                return pricing;
            }
            );
        },
    },

    actions: {
        async campCreationNextStep(context) {
            if (context.getters.campCreationStep === STEPS.length) {
                SCHOOL_APP.$emit('validate-camp-form');
            }
            else {
                context.commit(Mutations.CAMP_FORM_NEXT_STEP);
            }
        },

        async saveDraftCamp(context, activateDraftForm = false) {
            if (context.getters.campCreationStep === STEPS.length) {
                SCHOOL_APP.$emit('validate-camp-form-draft', activateDraftForm);
            }
        },


        async submitDraftCampForm(context, { showProrate, activateDraftForm }) {
            if (!context.getters.showProgress) {
                const campId = getCampId();
                const form = context.getters.campCreationForm;
                form.addOns.forEach(addOn => {
                    if (addOn.new) {
                        delete addOn.id;
                    }
                    delete addOn.new;
                });
                if (!context.getters.campFormAddOnsOpened) {
                    form.addOns = [];
                }
                if (campId) {
                    form.pricings.forEach(pricing => {
                        if (pricing.new) {
                            delete pricing.id;
                            delete pricing.new;
                            delete pricing.paid;
                        }else {
                            delete pricing.paid;
                        }
                    });

                    await SchoolCampService.editCamp(context.getters.schoolId, campId, {...context.getters.campCreationForm, draft: !activateDraftForm});
                    context.commit(Mutations.CAMP_FORM_SUBMIT);
                    router.push({name: Routes.CAMP_PAGE});
                    context.dispatch('createSuccessNotification', activateDraftForm ? 'You have successfully activated a camp' : 'You have successfully edited a camp');
                }
                else {
                    form.pricings.forEach(pricing => {
                        delete pricing.new;
                        delete pricing.id;
                        delete pricing.paid;
                    });
                    form.addOns.forEach(addOn => {
                        delete addOn.new;
                        delete addOn.id;
                    });
                    if (form.multiChildDiscount) {
                        delete form.multiChildDiscount.id;
                    }
                    if (form.multiProgramDiscount) {
                        delete form.multiProgramDiscount.id;
                    }
                    if (form.earlyBirdDiscount) {
                        delete form.earlyBirdDiscount.id;
                    }
                    form.addOns = form.addOns.filter(addOn => addOn.active);
                    if (!context.getters.campFormDetailsOpened) {
                        form.camp.pickUpOptions = false;
                        form.camp.pickUpOptionsRequired = false;
                        form.camp.teacher = false;
                        form.camp.teacherRequired = false;
                        form.camp.tshirt = false;
                        form.camp.tshirtRequired = false;
                    }
                    await SchoolCampService.createCamp(context.getters.schoolId, {...form, draft: true});
                    context.commit(Mutations.CAMP_FORM_SUBMIT);
                    context.getters.duplicateCampForm && context.commit(Mutations.CAMP_FORM_DUPLICATE_TOGGLE, false);
                }
            }
        },

        async prefillCampForm(context, campId) {
            const { data } = await SchoolCampService.getCamp(context.getters.schoolId, campId);
            const campDraftListResponse = await SchoolCampService.getCamps(context.getters.schoolId, PaginationParams.createParams({filters: {statuses: "DRAFT"}}));
            const draftIds = campDraftListResponse.data.content.map(i => i.id);
            const isDraft = draftIds.includes(data.camp.id);
            context.commit(Mutations.CAMP_FORM_SET_IS_DRAFT, isDraft);
            context.commit(Mutations.CAMP_FORM_DUPLICATE_TOGGLE, true);
            if (isDraft) {
                context.commit(Mutations.CAMP_FORM_PREFILL, {
                    ...data,
                    camp: validateCampDatesAndTimes(data.camp)
                });
            } else {
                context.commit(Mutations.CAMP_FORM_PREFILL, data);
            }
        },

        async submitCampForm(context) {
            if (!context.getters.showProgress) {
                const campId = getCampId();
                const form = context.getters.campCreationForm;
                form.addOns.forEach(addOn => {
                    if (addOn.new) {
                        delete addOn.id;
                    }
                    delete addOn.new;
                });
                if (!context.getters.campFormAddOnsOpened) {
                    form.addOns = [];
                }
                if (campId) {
                    form.pricings.forEach(pricing => {
                        if (pricing.new) {
                            delete pricing.id;
                            delete pricing.new;
                            delete pricing.paid;
                        }else {
                            delete pricing.paid;
                        }
                    });
                    await SchoolCampService.editCamp(context.getters.schoolId, campId, context.getters.campCreationForm);
                    context.commit(Mutations.CAMP_FORM_SUBMIT);
                    router.push({name: Routes.CAMP_PAGE});
                    context.dispatch('createSuccessNotification', 'You have successfully edited a camp');
                }
                else {
                    form.pricings.forEach(pricing => {
                        delete pricing.new;
                        delete pricing.id;
                        delete pricing.paid;
                    });
                    form.addOns.forEach(addOn => {
                        delete addOn.new;
                        delete addOn.id;
                    });
                    if (form.multiChildDiscount) {
                        delete form.multiChildDiscount.id;
                    }
                    if (form.multiProgramDiscount) {
                        delete form.multiProgramDiscount.id;
                    }
                    if (form.earlyBirdDiscount) {
                        delete form.earlyBirdDiscount.id;
                    }
                    form.addOns = form.addOns.filter(addOn => addOn.active);
                    if (!context.getters.campFormDetailsOpened) {
                        form.camp.pickUpOptions = false;
                        form.camp.pickUpOptionsRequired = false;
                        form.camp.teacher = false;
                        form.camp.teacherRequired = false;
                        form.camp.tshirt = false;
                        form.camp.tshirtRequired = false;
                    }
                    await SchoolCampService.createCamp(context.getters.schoolId, form);
                    context.commit(Mutations.CAMP_FORM_SUBMIT);
                    context.getters.duplicateCampForm && context.commit(Mutations.CAMP_FORM_DUPLICATE_TOGGLE, false);
                }
            }
        },

        goToCampCreationStep(context, number) {
            context.commit(Mutations.CAMP_FORM_GOTO_STEP, number);
        },

        goToCampCreationStart(context) {
            context.dispatch('goToCampCreationStep', 1);
            context.commit(Mutations.CAMP_FORM_SUBMIT, false);
        },

        resetCampForm(context) {
            context.commit(Mutations.CAMP_FORM_RESET);
        }

    },

    getters: {
        campCreationStep: state => state.step,

        campCreationForm: state => state.form,

        campCreationSteps: state => state.steps,

        campCreationFormDisabled: state => state.steps &&
        state.step === state.steps.length ?
            state.steps.some(step => !step.valid) :
            !state.steps[state.step - 1].valid,

        campCreationType: state => state.form.gradeFrom ? TYPES[0] : TYPES[1],

        campCreationFormSubmitted: state => state.isSubmitted,

        campFormDiscountsOpened: state => state.discountsOpened,

        campFormAddOnsOpened: state => state.addOnsOpened,

        campFormDetailsOpened: state => state.detailsOpened,

        campFormDirty: state => !_.isEqual(state.form, state.formCopy),

        duplicateCampForm: state => state.duplicateCampForm,

        isCampFormDraft: state => state.isDraft,

        validateCampEarlyBirdDiscountExeption: state => {
            return state.form && isEditForm() && !state.isDraft
        },
        
        isCampCostEditingDisabled: (state) => {
            if (state.form && isEditForm()) {
                return !state.isDraft;
            }
            return false;
        }
    }
};

function getCampId() {
    return router.app._route.params.id;
}

function isEditForm() {
    return !!getCampId();
}

function validateCampDatesAndTimes(campData) {
    const now = moment();
  
    // Ensure dates are not in the past
    if (moment(campData.campStartDate).isBefore(now, "day")) {
      campData.campStartDate = now.format("YYYY-MM-DD");
    }
  
    if (moment(campData.campEndDate).isBefore(now, "day")) {
      campData.campEndDate = now.format("YYYY-MM-DD");
    }
  
    if (moment(campData.signUpBeginsDate).isBefore(now, "day")) {
      campData.signUpBeginsDate = now.format("YYYY-MM-DD");
    }
  
    if (moment(campData.signUpEndsDate).isBefore(now, "day")) {
      campData.signUpEndsDate = now.format("YYYY-MM-DD");
    }
  
    // Validate sign-up date + time combinations
    const signUpBeginsDateTime = moment(`${campData.signUpBeginsDate} ${campData.signUpBeginsTime}`, "YYYY-MM-DD HH:mm");
    const signUpEndsDateTime = moment(`${campData.signUpEndsDate} ${campData.signUpEndsTime}`, "YYYY-MM-DD HH:mm");
  
    if (signUpBeginsDateTime.isBefore(now)) {
      campData.signUpBeginsDate = now.format("YYYY-MM-DD");
      campData.signUpBeginsTime = now.format("HH:mm");
    }
  
    if (signUpEndsDateTime.isBefore(now)) {
      campData.signUpEndsDate = now.format("YYYY-MM-DD");
      campData.signUpEndsTime = now.format("HH:mm");
    }
  
    return campData;
  }


// WEBPACK FOOTER //
// ./src/store/modules/camp-form/camp-form.module.js